import { render, staticRenderFns } from "./changePhone.vue?vue&type=template&id=145e34b8"
import script from "./changePhone.vue?vue&type=script&lang=js"
export * from "./changePhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports